import {
    useDeleteAdminConversationFormQuery,
    useDuplicateAdminConversationFormQuery,
    useSortAdminConversationFormQuery,
} from '@entities/AdminConversationCategory';
import { IForm } from '@entities/AdminConversationCategory/model/types';

export const useAdminConversationForm = (form: IForm) => {
    const redirectToList = () => {
        window.location.href = `/admin/conversation/list?formId=${form.id}&type=${form.type}`;
    };

    const { mutateAsync: mutateAsyncDeleteAdminConversationForm } =
        useDeleteAdminConversationFormQuery();

    const { mutateAsync: mutateAsyncDuplicateAdminConversationForm } =
        useDuplicateAdminConversationFormQuery();

    const { mutateAsync: mutateAsyncSortAdminConversationForm } =
        useSortAdminConversationFormQuery();

    const onDeleteForm = async () => {
        await mutateAsyncDeleteAdminConversationForm(form.id);
    };

    const onDuplicateForm = async () => {
        await mutateAsyncDuplicateAdminConversationForm(form.id);
    };

    const onSortForm = async (type: string) => {
        await mutateAsyncSortAdminConversationForm({
            id: form.id,
            type,
        });
    };
    return { redirectToList, onSortForm, onDuplicateForm, onDeleteForm };
};
